import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Target, Thermometer, Clock, Coffee } from 'lucide-react';
export function DeliverablesSection() {
  const items = [{
    icon: <BookOpen className="w-6 h-6 text-navy" data-id="element-33" />,
    title: 'Guía Cuna de Hierro (PDF)',
    desc: 'El paso a paso exacto para dominar la transferencia.'
  }, {
    icon: <Target className="w-6 h-6 text-navy" data-id="element-34" />,
    title: 'El Radar del Sueño',
    desc: "Cómo detectar la 'Ventana de Oro' de 15 minutos antes del sobre-cansancio."
  }, {
    icon: <Thermometer className="w-6 h-6 text-navy" data-id="element-35" />,
    title: 'Mapa de Entorno Blindado',
    desc: 'Configuración de luz, ruido y temperatura para el clima de USA.'
  }, {
    icon: <Clock className="w-6 h-6 text-navy" data-id="element-36" />,
    title: 'Técnica de Rescate de Siesta',
    desc: 'Qué hacer cuando se despierta a los 20 minutos.'
  }, {
    icon: <Coffee className="w-6 h-6 text-navy" data-id="element-37" />,
    title: "El 'Dream Feed' Seguro",
    desc: 'Cómo alimentarlo a las 10 PM para que tú duermas 6 horas seguidas.'
  }];
  return <section className="bg-cream py-24 px-6" data-id="element-38">
      <div className="max-w-4xl mx-auto" data-id="element-39">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-40">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy mb-4" data-id="element-41">
            Lo que obtienes hoy
          </h2>
          <div className="w-16 h-1 bg-gold mx-auto rounded-full" data-id="element-42"></div>
        </motion.div>

        <div className="space-y-4" data-id="element-43">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white p-6 rounded-xl shadow-sm border border-navy/5 flex items-center gap-6 hover:shadow-md transition-shadow" data-id="element-44">
              <div className="bg-gold/20 p-4 rounded-full shrink-0" data-id="element-45">
                {item.icon}
              </div>
              <div data-id="element-46">
                <h3 className="font-bold text-navy text-lg" data-id="element-47">{item.title}</h3>
                <p className="text-navy/70 mt-1" data-id="element-48">{item.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}